const calendar = require("../assets/icons/calendar.png");
const check = require("../assets/icons/check.png");
const checkCircle = require("../assets/icons/check-circle.png");
const comment = require("../assets/icons/comment.png");
const eye = require("../assets/icons/eye.png");
const eyeClosed = require("../assets/icons/eye-closed.png");
const feed = require("../assets/icons/feed.png");
const logo = require("../assets/icons/logo.png");
const notification = require("../assets/icons/notification.png");
const plus = require("../assets/icons/plus.png");
const search = require("../assets/icons/search.png");
const timeline = require("../assets/icons/timeline.png");
const user = require("../assets/icons/user.png");
const traffic = require("../assets/icons/traffic.png");
const clock = require("../assets/icons/clock.png");
const arrowsVertical = require("../assets/icons/arrows-vertical.png");
const arrowDown = require("../assets/icons/arrow-down.png");
const arrowUp = require("../assets/icons/arrow-up.png");
const arrowLight = require("../assets/icons/arrow-light.png");
const attachments = require("../assets/icons/attachments.png");
const share = require("../assets/icons/share.png");
const bin = require("../assets/icons/bin.png");
const options = require("../assets/icons/options.png");
const word = require("../assets/icons/word.png");
const excel = require("../assets/icons/excel.png");
const powerpoint = require("../assets/icons/powerpoint.png");
const sketch = require("../assets/icons/sketch.png");
const folder = require("../assets/icons/folder.png");
const sharedFolder = require("../assets/icons/sharedFolder.png");
const pin = require("../assets/icons/pin.png");
const alert = require("../assets/icons/alert.png");
const info = require("../assets/icons/info.png");
const upload = require("../assets/icons/upload.png");
const file = require("../assets/icons/file.png");
const task = require("../assets/icons/task.png");
const close = require("../assets/icons/close.png");
const settings = require("../assets/icons/settings.png");
const pencil = require("../assets/icons/pencil.png");
const help = require("../assets/icons/help.png");
const customize = require("../assets/icons/customize.png");
const camera = require("../assets/icons/camera.png");
const lock = require("../assets/icons/lock.png");
const download = require("../assets/icons/download.png");
const emoji = require("../assets/icons/emoji.png");
const phone = require("../assets/icons/phone.png");
const message = require("../assets/icons/message.png");
const cellphone = require("../assets/icons/cellphone.png");
const star = require("../assets/icons/star.png");
const home = require("../assets/icons/home.png");
const currency = require("../assets/icons/currency.png");
const history = require("../assets/icons/history.png");
const closeCircle = require("../assets/icons/close-circle.png");
const heartOutlined = require("../assets/icons/heart-outlined.png");
const heartFilled = require("../assets/icons/heart-filled.png");
const send = require("../assets/icons/send.png");
const reload = require("../assets/icons/reload.png");
const addUser = require("../assets/icons/add-user.png");
const addPost = require("../assets/icons/add-post.png");
const success = require("../assets/icons/success.png");
const video = require("../assets/icons/video.png");
const play = require("../assets/icons/play.png");
const pause = require("../assets/icons/pause.png");
const article = require("../assets/icons/article.png");
const mic = require("../assets/icons/mic.png");
const micOff = require("../assets/icons/mic-off.png");
const phoneOff = require("../assets/icons/phone-off.png");
const cameraOff = require("../assets/icons/camera-off.png");
const edit = require("../assets/icons/edit.png");
const flash = require("../assets/icons/flash.png");
const text = require("../assets/icons/text.png");

// social icons
const apple = require("../assets/icons/apple.png");
const facebook = require("../assets/icons/facebook.png");
const google = require("../assets/icons/google.png");

export default {
  calendar,
  check,
  checkCircle,
  comment,
  eye,
  eyeClosed,
  feed,
  logo,
  notification,
  plus,
  search,
  timeline,
  user,
  traffic,
  clock,
  arrowsVertical,
  arrowDown,
  arrowUp,
  arrowLight,
  attachments,
  share,
  bin,
  options,
  word,
  excel,
  powerpoint,
  sketch,
  folder,
  sharedFolder,
  pin,
  alert,
  info,
  upload,
  file,
  task,
  close,
  settings,
  pencil,
  help,
  customize,
  camera,
  lock,
  download,
  emoji,
  phone,
  message,
  cellphone,
  star,
  home,
  currency,
  history,
  closeCircle,
  heartOutlined,
  heartFilled,
  send,
  apple,
  facebook,
  google,
  reload,
  addUser,
  addPost,
  success,
  video,
  article,
  play,
  pause,
  mic,
  micOff,
  phoneOff,
  cameraOff,
  edit,
  flash,
  text,
};
